import {
  ManufacturingModelsModeToggle,
  ManufacturingModelsWorkspaceToggle,
  type ManufacturingModelsMode,
  type ManufacturingModelsWorkspace,
} from "./ManufacturingModelsModeToggle";
import { ManufacturingVariantDeficitsControl } from "./ManufacturingVariantDeficitsControl";
import { ManufacturingModelsAiAssistantLauncher } from "./ManufacturingModelsAiAssistantLauncher";

/** Title + workspace tabs + variant-deficits control (+ create/view when on Models).
 * Recipe Bulk import / Export live in ManufacturingModelsRecipeToolsActions (all slides). */
export function ManufacturingModelsWorkspaceChrome({
  workspace,
  onWorkspaceChange,
  mode,
  onModeChange,
  showModeToggle,
  deficitsEnabled,
  deficitsRefreshTick,
  onReviewDeficitUse,
  aiAssistantEnabled,
  aiAssistantLoading,
  onAiAssistantOpenRecipe,
  onAiAssistantCatalogMutated,
}: {
  workspace: ManufacturingModelsWorkspace;
  onWorkspaceChange: (next: ManufacturingModelsWorkspace) => void;
  mode: ManufacturingModelsMode;
  onModeChange: (next: ManufacturingModelsMode) => void;
  showModeToggle: boolean;
  deficitsEnabled: boolean;
  deficitsRefreshTick: number;
  onReviewDeficitUse: (useId: string) => void;
  aiAssistantEnabled: boolean;
  aiAssistantLoading: boolean;
  onAiAssistantOpenRecipe?: (recipeId: string) => void;
  onAiAssistantCatalogMutated?: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Models (BOM)</h2>
      <ManufacturingModelsAiAssistantLauncher
        enabled={aiAssistantEnabled}
        loading={aiAssistantLoading}
        onOpenRecipe={onAiAssistantOpenRecipe}
        onCatalogMutated={onAiAssistantCatalogMutated}
      />
      <ManufacturingModelsWorkspaceToggle workspace={workspace} onChange={onWorkspaceChange} />
      <ManufacturingVariantDeficitsControl
        enabled={deficitsEnabled}
        refreshTick={deficitsRefreshTick}
        onReviewUse={onReviewDeficitUse}
      />
      {showModeToggle ? (
        <ManufacturingModelsModeToggle mode={mode} onChange={onModeChange} />
      ) : null}
    </div>
  );
}
